import { render, staticRenderFns } from "./ParagraphComponent.vue?vue&type=template&id=044e4ca1&"
import script from "./ParagraphComponent.vue?vue&type=script&lang=js&"
export * from "./ParagraphComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ParagraphComponent.vue"
export default component.exports